import { Injectable, NgZone, OnDestroy } from '@angular/core'
import { monitorForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter'
import { CleanupFn } from '@atlaskit/pragmatic-drag-and-drop/types'
import { Observable, Subject } from 'rxjs'
import { TbDragDropEvent } from './drag-drop.types'

/**
 * Monitors for global drag and drop events.
 */
@Injectable({ providedIn: 'root' })
export class TbDragDropMonitorService implements OnDestroy {
    private readonly onDropSubject = new Subject<TbDragDropEvent>()

    /**
     * Emits global element drag `onDrop` events.
     */
    readonly onDrop$: Observable<TbDragDropEvent> = this.onDropSubject.asObservable()

    private cleanupFn!: CleanupFn

    constructor(private readonly ngZone: NgZone) {
        this.cleanupFn = this.ngZone.runOutsideAngular(() =>
            monitorForElements({
                onDrop: (args) => {
                    this.ngZone.run(() => this.onDropSubject.next(args as TbDragDropEvent))
                },
            }),
        )
    }

    ngOnDestroy(): void {
        this.cleanupFn()
    }
}
